// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AutoCompleteNoPlacesCmp$PorterinFeature from "./AutoCompleteNoPlacesCmp.mjs";
import * as AutoCompleteCardSectionCmp$PorterinFeature from "./AutoCompleteCardSectionCmp.mjs";

function AutoCompleteSuggestionsCmp(Props) {
  var places_list = Props.places_list;
  var on_address_select = Props.on_address_select;
  var match = places_list.length;
  if (match !== 0) {
    return React.createElement(AutoCompleteCardSectionCmp$PorterinFeature.make, {
                places_list: places_list,
                on_address_select: Curry.__1(on_address_select)
              });
  } else {
    return React.createElement(AutoCompleteNoPlacesCmp$PorterinFeature.make, {});
  }
}

var make = AutoCompleteSuggestionsCmp;

export {
  make ,
}
/* react Not a pure module */
